/**
 *  Status values of the OpenTicketBase class
 */
export var State;
(function (State) {
    State["Start"] = "start";
    State["Initializing"] = "initializing";
    State["Waiting"] = "waiting";
    State["Loading"] = "loading";
    State["Ready"] = "ready";
    State["Error"] = "error";
})(State || (State = {}));
//# sourceMappingURL=types.js.map